import React, { ReactElement } from 'react';
import styled from 'styled-components';

export const FormContainerContainer = styled.div<{ background?: string, width?: number | string }>`
  background: ${(props) => props.background || 'transparent'};
  border-radius: 12px;
  position: relative;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.Mobile}) {
    max-width: ${(props) => typeof props.width === 'number' ? `${props.width || 680}px` : props.width || '100%'};
  }
`;

type FormContainerProps = {
  children: ReactElement | ReactElement[];
  className?: string;
  onPaste?: (evt: any) => void;
  width?: number | string;
  background?: string;
};

function FormContainer(props: FormContainerProps): ReactElement {
  const {
    children,
    className = 'form-container',
    onPaste = () => { },
    width = 680,
    background = '',
  } = props;

  return (
    <FormContainerContainer
      background={background}
      width={width}
      className={className}
      onPaste={onPaste}
    >
      {children}
    </FormContainerContainer>
  );
}

export default FormContainer;
